function isValidPartner(partnerRef: string) {
  const validPartnerRefs = ['1904'];
  return validPartnerRefs.includes(partnerRef);
}

const patterns = [
  /^[a-zA-Z]{2}[\d]{2}[\d]{2}$/, //   1       XX-99-99
  /^[\d]{2}[\d]{2}[a-zA-Z]{2}$/, //   2       99-99-XX
  /^[\d]{2}[a-zA-Z]{2}[\d]{2}$/, //   3       99-XX-99
  /^[a-zA-Z]{2}[\d]{2}[a-zA-Z]{2}$/, //   4       XX-99-XX
  /^[a-zA-Z]{2}[a-zA-Z]{2}[\d]{2}$/, //   5       XX-XX-99
  /^[\d]{2}[a-zA-Z]{2}[a-zA-Z]{2}$/, //   6       99-XX-XX
  /^[\d]{2}[a-zA-Z]{3}[\d]{1}$/, //   7       99-XXX-9
  /^[\d]{1}[a-zA-Z]{3}[\d]{2}$/, //   8       9-XXX-99
  /^[a-zA-Z]{2}[\d]{3}[a-zA-Z]{1}$/, //   9       XX-999-X
  /^[a-zA-Z]{1}[\d]{3}[a-zA-Z]{2}$/, //   10      X-999-XX
  /^[a-zA-Z]{3}[\d]{2}[a-zA-Z]{1}$/, // 11      XXX-99-X
];

const getLicencePlateType = (val) => {
  const value = val.replace(/-/g, '').toUpperCase();

  const exceptions = '^CD[ABFJNST][0-9]{1,3}$'; // except licenseplates for diplomats

  for (let i = 0; i < patterns.length; i++) {
    if (value.match(patterns[i])) {
      return i + 1;
    }
  }

  if (value.match(exceptions)) {
    return 'CD';
  }

  return false;
};

const prettifyLicencePlate = (value: string): string => {
  if (!value) return value;

  const upperCaseValue = value.toUpperCase();
  const normalizedInput = upperCaseValue.replace(/\s/g, '-');
  if (normalizedInput.length < 6) return normalizedInput;

  const code = getLicencePlateType(normalizedInput);

  if (!code) return normalizedInput;

  const rawLicensePlateValue = normalizedInput.replace(/-/g, '');

  if (typeof code === 'number') {
    if (code <= 6) {
      return `${rawLicensePlateValue.substr(0, 2)}-${rawLicensePlateValue.substr(
        2,
        2,
      )}-${rawLicensePlateValue.substr(4, 2)}`;
    }
    if (code === 7 || code === 9) {
      return `${rawLicensePlateValue.substr(0, 2)}-${rawLicensePlateValue.substr(
        2,
        3,
      )}-${rawLicensePlateValue.substr(5, 1)}`;
    }
    if (code === 8 || code === 10) {
      return `${rawLicensePlateValue.substr(0, 1)}-${rawLicensePlateValue.substr(
        1,
        3,
      )}-${rawLicensePlateValue.substr(4, 2)}`;
    }
    if (code === 11) {
      return `${rawLicensePlateValue.substr(0, 3)}-${rawLicensePlateValue.substr(
        3,
        2,
      )}-${rawLicensePlateValue.substr(5, 1)}`;
    }
  }

  if (code === 'CD') {
    return rawLicensePlateValue;
  }

  return rawLicensePlateValue;
};

export { isValidPartner, prettifyLicencePlate };
